Ext.define('SA.Features', {
    singleton: true,

    hasAcsTable() {
        return this.hasParam('acs');
    },

    hasAnyParam(params) {
        return params.some(param => this.hasParam(param));
    },

    hasHierarchicalDataSearch() {
        return this.hasParam('hierarchicaldatasearch');
    },

    hasParam(param) {
        var params = new URLSearchParams(location.search),
            paramKeys = [...params.keys()].map(key => key.toLowerCase());

        return paramKeys.includes(param.toLowerCase());
    }
});